import { useUpdateExternalUserNameMutation } from 'src/types/generated'

type UpdateNameInput = {
  userId: number
  updatedName: string
}

export const useExternalUser = () => {
  const [updateExternalUserNameMutation] = useUpdateExternalUserNameMutation()
  const updateName = async ({ userId, updatedName }: UpdateNameInput): Promise<void> => {
    await updateExternalUserNameMutation({ variables: { userId, name: updatedName } })
  }

  return {
    updateName,
  }
}
